// extracted by mini-css-extract-plugin
module.exports = {"confirmDialog":"ConfirmDialog_confirmDialog__wKwxi"};